import React, { useEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import getContentProps from '../get-content-props'
import { inheritPrimaryColor } from '../colors'
import { Link } from 'react-router-dom'

const LatestPost = styled(({ newsItem, ...props }) => {
  useEffect(() => {
    const iframes = document.getElementsByTagName("IFRAME")
    for (let iframe of iframes) {
      iframe.height = null
      iframe.width = null
    }
  })

  return (
    <div {...props}>
      <div css='max-width: 1140px; flex-grow: 1; display: flex; flex-direction: column;'>
        <h1 css='font-weight: 100; margin-top: 10px; margin-bottom: 30px; font-size: 80px; color: rgb(210, 210, 210);'>Latest News</h1>
        <div css='display: flex; justify-content: center;'>
          <NewsSummary backgroundColor='rgb(245, 245, 245)' date={newsItem.date} content={newsItem.acf.content} slug={newsItem.slug} title={newsItem.title.rendered} />
        </div>
        <Link to={`/news`} css={css`align-self: center; margin: 20px; text-decoration: none; border-radius: 2px; transition: background-color 0.2s, color 0.2s; padding: 6px 12px; font-size: 1.2em; border: 3px solid ${inheritPrimaryColor}; background-color: ${inheritPrimaryColor}; color: white; font-weight: 500; &:hover {color: ${inheritPrimaryColor}; background-color: transparent;}`}>VIEW ALL NEWS</Link>
      </div>
    </div>
  )
})`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  background-color: rgb(245, 245, 245);
  padding: 0px 20px 60px;
  min-height: 500px;
border-top: 1px solid rgb(240, 240, 240);
`

const NewsSummary = styled(({ date, slug, title, content, maxHeight = '350px', backgroundColor = 'white', ...props }) => {
  return (
    <div {...props}>
      <div css={`max-height: ${maxHeight}; position: relative; overflow: hidden; font-size: 1.15em; line-height: 1.7em; color: rgb(100, 100, 100);`}>
        <Link css={css`color: ${inheritPrimaryColor}; text-decoration: none;`} to={`/news/${slug}`}>
          <h1 css={`display: inline-block; font-weight: 400; line-height: 1.15em; margin-bottom: 0px; &:hover { text-decoration: underline }`}>{title}</h1>
        </Link>
        <DateTag>{date.replace('T', ' ')}</DateTag>
        {content && <>
          <div {...getContentProps(content)} />
          <div css={css`pointer-events: none; position: absolute; bottom: 0px; right: 0px; left: 0px; height: 100px; background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), ${backgroundColor});`}></div>
        </>}
      </div>

      {content && <Link to={`/news/${slug}`} css={css`align-self: center; color: ${inheritPrimaryColor}`}>Read more</Link>}
    </div>
  )
})`
  flex-grow: 1;
  max-width: 800px;
  display: flex;
  flex-direction: column;
`

const DateTag = styled.div`
  color: rgb(170, 170, 170);
  font-size: 0.9em;
  margin-bottom: 1.5em;
`

export default LatestPost